// extracted by mini-css-extract-plugin
export var bubble = "_3i-0";
export var container = "_3i-3";
export var contrastBorder = "_3i-4";
export var greyOut = "_3i-2";
export var initialsWrapper = "_3i-1";
export var large = "_3i-9";
export var medium = "_3i-8";
export var mediumSmall = "_3i-7";
export var mediumSmallMedium = "_3i-c";
export var micro = "_3i-5";
export var small = "_3i-6";
export var tiny = "_3i-b";
export var xTiny = "_3i-a";